var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-datatable-wrapper"},[_c('div',{staticClass:"sf-datatable-container"},[_c('sf-data-table',{ref:"dataTable",attrs:{"pageUnit":10,"columns":_vm.column,"rows":_vm.rows,"index":true,"height":"500px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }